import {svgIconWrapper} from '../svg-icon-wrapper';

import UndoRegular from './undo-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <UndoRegular {...validProps} />;
}

SvgComponent.iconName = 'undo-regular';

export const UndoRegularIcon = svgIconWrapper(SvgComponent);
